import React from 'react';
import './JoinStatus.css';

export default function JoinStatus({ join }) {
  const pendingSdk = join.sdk === 'running' || join.sdk === 'pending' || join.waitingForProvider;
  const stage = join.meta === 'invalid' ? 'Check your video link' :
    join.meta === 'pending' ? 'Loading meeting details' :
    join.meta === 'scheduled' ? 'Waiting to retry meeting details' :
    join.meta === 'error' || join.meta === 'waiting' || join.meta === 'stopped' ? 'Meeting details need attention' :
    join.sdk === 'error' ? (join.useDefaults ? 'Using the default appearance' : 'Meeting details ready') : 'Connecting video';
  return <main className="join-status">
    <section className="join-status__card" aria-labelledby="join-title">
      <h1 id="join-title">Preparing your video chat</h1>
      <p role="status" aria-live="polite">{stage}</p>
      <div role="status" aria-live="polite">{join.sdk === 'error' ? `Video connection needs attention: ${join.sdkMessage}` : ''}</div>
      {(join.meta === 'pending' || pendingSdk || join.meta === 'scheduled') && <progress aria-label="Joining video chat" />}
      <p>Elapsed: {join.elapsed} seconds</p>
      {join.attempt > 0 && !join.metadata && <p>Meeting details: attempt {join.attempt} of 3</p>}
      {join.message && <p>{join.message}</p>}
      {join.useDefaults && <p>Using the default appearance for this video chat.</p>}
      {join.sdkMessage && join.sdk !== 'error' && <p>{join.sdkMessage}</p>}
      {pendingSdk && <p>Look for a browser prompt to allow your camera and microphone. You can choose your devices in the setup screen.</p>}
      {pendingSdk && join.showHelp && <p>Still waiting? Check for a hidden permission prompt and your browser and system settings.</p>}
      {join.meta === 'pending' && join.showHelp && <p>Still waiting for meeting details? Check your connection or ask the host for help.</p>}
      {join.offline && <p>{join.meta === 'scheduled'
        ? 'You appear to be offline. The scheduled retry will resume when your connection returns.'
        : join.meta === 'pending' && join.attempt === 0
          ? 'You appear to be offline. Meeting details will load when your connection returns.'
          : 'You appear to be offline. Check your connection.'}</p>}
      {join.meta === 'scheduled' && !join.offline && <p>Next retry in {join.countdown} seconds</p>}
      {join.gated && <p>Please wait {join.countdown} seconds before trying again.</p>}
      <div className="join-status__actions">
        {join.meta === 'scheduled' && <button onClick={join.stop}>Stop retries</button>}
        {['scheduled', 'error', 'waiting', 'stopped'].includes(join.meta) && <button disabled={join.offline || join.gated} onClick={join.retryNow}>{join.meta === 'scheduled' ? 'Retry now' : 'Try meeting details again'}</button>}
        {join.allowUnthemed && <button onClick={join.continueUnthemed}>Continue without theme</button>}
        {(join.sdk === 'error' || (pendingSdk && join.showReload)) && <button onClick={() => window.location.reload()}>Reload video chat</button>}
      </div>
    </section>
  </main>;
}
